import React, { Component } from "react";
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButtons, IonButton, isPlatform } from "@ionic/react";

import { App } from "@capacitor/app";

// CSS
import "./InfoPage.css";
import "../../Shared.css";
import "../../../App.css";

// Images
import iconClose from "../../assets/Button_Close@3x.png";

// Controllers
import { IScreenProps, IUser } from "../../Interfaces";

// Components

type Props = { close?: () => void; screenProps: IScreenProps; features: string[] };
type State = {};

class InfoPage extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  async componentDidMount() {}

  close() {
    if (this.props.close) {
      this.props.close();
    }
  }

  supportEmail(event: any) {
    this.props.screenProps.sendSupportEmail("Subscription Support");
  }

  render() {
    let infoHtml = null;

    if (this.props.screenProps.app === "iCPG") {
      let trustHtml = "";

      if (this.props.screenProps.trustInfo) {
        let trustInfo = this.props.screenProps.trustInfo.find((trustInfo) => trustInfo.trust === "iCPG");
        if (trustInfo != null) {
          trustHtml = trustInfo.html;
        }
      }

      infoHtml = (
        <div>
          <div dangerouslySetInnerHTML={{ __html: trustHtml }} />
        </div>
      );
    } else if (this.props.screenProps.app === "CFR") {
      let trustHtml = "";

      if (this.props.screenProps.trustInfo) {
        let trustInfo = this.props.screenProps.trustInfo.find((trustInfo) => trustInfo.trust === "CFR");
        if (trustInfo != null) {
          trustHtml = trustInfo.html;
        }
      }

      infoHtml = (
        <div>
          <div dangerouslySetInnerHTML={{ __html: trustHtml }} />
        </div>
      );
    } else {
      let trustHtml = "";

      if (this.props.screenProps.trustInfo) {
        if (this.props.screenProps.user && this.props.screenProps.trust !== "") {
          let trustInfo = this.props.screenProps.trustInfo.find(
            (trustInfo) => trustInfo.trust === this.props.screenProps.trust
          );
          if (trustInfo != null) {
            trustHtml = trustInfo.html;
          }
        }
      }

      infoHtml = (
        <div>
          <div dangerouslySetInnerHTML={{ __html: trustHtml }} />
        </div>
      );
    }

    return (
      <IonPage>
        <IonHeader>
          <IonToolbar mode="ios" className="navBar">
            <IonTitle>App information</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={this.close.bind(this)}>
                <img className="icon-44" src={iconClose} />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen className="modalContent">
          <div className="helpAndInfoContent">{infoHtml}</div>
        </IonContent>
      </IonPage>
    );
  }
}

export default InfoPage;
